<template>
    <div class="l-inner">
        <app-section
            :title="page.title"
            :desc="page.desc"
            :push="page.push"
            bgIntro="lighter"
            :btnReturn="btnReturn"
            :video-url="page.video_hero"
            intro-position="bottom"
            :page="page"
            :strap="page.business"
        >
            <template #content>
                <div class="p-stories__grid | l-grid">
                    <!-- intro -->
                    <hero-card :data="findCard('card_hero', page.body)" />
                    <entrepreneur-vertical-name
                        v-if="page.first_name && page.last_name"
                        :first-name="page.first_name[0].text"
                        :last-name="page.last_name[0].text"
                    />
                    <entrepreneur-thumbnail :img="page.card_image" bg="dark" />
                    <entrepreneur-title-text :data="findCard('intro_entrepreneur', page.body)" />

                    <div v-for="(item, index) in page.body" :key="index" class="p-stories__grid__body">
                        <!-- this could be potentially refactored -->
                        <entrepreneur-quote
                            v-if="item.slice_type === 'quote'"
                            :data="item"
                            :first-name="page.first_name[0].text"
                            :last-name="page.last_name[0].text"
                        />
                        <entrepreneur-parallax :item="item" v-if="item.slice_type === 'parallax'" :data="item" />
                        <entrepreneur-title-text v-if="item.slice_type === 'intro_entrepreneur1'" :data="item" />
                        <entrepreneur-video
                            v-if="item.slice_type === 'video_entrepreneur'"
                            :data="item"
                            :bg="item.primary.bg"
                        />
                    </div>
                </div>
            </template>
        </app-section>
        <push :page="push" :is-entrepreneur-page="true" />
        <about />
    </div>
</template>

<script>
import { mapState } from "vuex";

import About from "layout/About";
import AnimText from "objects/AnimText";
import AppSection from "layout/AppSection";
import EntrepreneurParallax from "components/EntrepreneurParallax/EntrepreneurParallax";
import EntrepreneurQuote from "components/EntrepreneurQuote/EntrepreneurQuote";
import EntrepreneurThumbnail from "components/EntrepreneurThumbnail/EntrepreneurThumbnail";
import EntrepreneurTitleText from "components/EntrepreneurTitleText/EntrepreneurTitleText";
import EntrepreneurVerticalName from "components/EntrepreneurVerticalName/EntrepreneurVerticalName";
import EntrepreneurVideo from "components/EntrepreneurVideo/EntrepreneurVideo";
import HeroCard from "components/HeroCard/HeroCard";
import Icon from "objects/Icon";
import Push from "layout/Push";

export default {
    name: "Story",
    components: {
        About,
        AnimText,
        AppSection,
        EntrepreneurParallax,
        EntrepreneurQuote,
        EntrepreneurThumbnail,
        EntrepreneurTitleText,
        EntrepreneurVerticalName,
        EntrepreneurVideo,
        HeroCard,
        Icon,
        Push,
    },
    props: {
        page: Object,
    },
    data() {
        return {};
    },
    computed: {
        ...mapState({
            currentPage: (state) => state.global.currentPage,
        }),

        btnReturn() {
            return {
                label: this.$t("btn.allStories"),
                path: "/",
            };
        },
        push() {
            const handle = this.$route.meta.prismicHandle;
            return this.$store.getters["global/getNextRepeatable"](handle, this.currentPage.id);
        },
    },
    methods: {
        ////////////////////////////////
        //       START FIND A DATA BY SLICE TYPE
        ////////////////////////////////
        findCard(sliceType, data) {
            return data.find((x) => x.slice_type === sliceType);
        },
        ////////////////////////////////
        //       END FIND A DATA BY SLICE TYPE
        ////////////////////////////////
    },
};
</script>

<style lang="scss">
.p-story {
    @media #{$breakpoint-horizontal} {
        .l-section__intro {
            min-width: 45em;
        }
    }

    .c-hero-card {
        &:nth-child(1) {
            @media #{$breakpoint-vertical} {
                margin-bottom: var(--grid-gutter-triple);
            }
        }
    }
    .entrepreneur-thumbnail {
        @media #{$breakpoint-vertical} {
            padding-top: 0px;
        }
    }
}

.p-story__grid {
    @media #{$breakpoint-horizontal} {
        .c-card {
            &:nth-child(even) {
                margin-top: 0;
                margin-bottom: auto;
            }

            &:nth-child(odd) {
                margin-top: auto;
                margin-bottom: 0;
            }

            &.-simple {
                margin-top: auto;
                margin-bottom: auto;
            }
        }
    }
    /* &__body {
    display: flex;
    height: 100%;
  } */
}
.p-stories__grid__body {
    display: flex;
    height: 100%;
}
</style>
